interface IProps {
  theme: 'dark' | 'light';
  isOpen: boolean;
}

export const MiniWhiteArrow = ({ theme, isOpen }: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M7 14.9082L12 9.9082L17 14.9082H7Z" fill={theme === 'dark' || isOpen ? 'white' : 'black'}/>
    </svg>
  );
};